import React from "react"
import _ from "lodash"
import I18n from "@helper/i18nInstance"

import Countdown from "@Quiz/Question/Countdown"

// when more locales: pass locale dynamically here instead of hardcoding "de"
const prettyScore = (value: number): string =>
  new Intl.NumberFormat("de", { maximumFractionDigits: 0 }).format(value)

export const IntroductionRaw: React.FC<{text: string}> = ({text}) => {
  return (
    <div className="neo__quizIntroduction" dangerouslySetInnerHTML={{__html: text}}/>
  )
}

export const Introduction = React.memo(IntroductionRaw)

export const ReleasedAt: React.FC<{date: string}> = ({date}) => {
  return <div className="neo__quizRealeasedAt" data-testid="quiz-released-at">{I18n.t("quiz.meta.released_at", { date })}</div>
}

export const HeaderPoints: React.FC<{current: number, total?: number}> = ({current, total}) => {
  const withTotal = _.isNumber(total)
  return <span>
    {withTotal
      ? I18n.t("quiz.meta.points_with_total", {
          current: prettyScore(current),
          total: prettyScore(total as number)})
      : I18n.t("quiz.meta.points_without_total", {
          current: prettyScore(current)})}
  </span>
}

export const QuestionHeader: React.FC<{meta: Quiz.Api.Meta}> = ({ meta }) => {
  return <>
    <div className="neo__quizHeader">
      <span>{meta.question_results.length + 1} / {meta.num_questions}</span>
      {!meta.hide_points && <HeaderPoints current={meta.points} total={meta.possible_points} />}
    </div>
    <Countdown />
  </>
}

export const Busy: React.FC = () => {
  return (
    <div className="neo__quizBusy" data-testid="quiz-busy">
      <div className="neo__quizBusy__spinner" />
    </div>
  )
}